import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { getAssetKindValueLabel } from "./assetTypeOptions";

const StyledImg = styled.img`
  width: ${(props) => props.width}px;
  height: auto;
  filter: ${(props) =>
    props.$white
      ? "invert(100%) sepia(0%) saturate(0%) hue-rotate(61deg) brightness(103%) contrast(105%)"
      : props.$isDefault
      ? "none"
      : "invert(15%) sepia(55%) saturate(4945%) hue-rotate(267deg) brightness(93%) contrast(94%)"};
`;

export default function AssetsIcon({ assetKind, width = 16, white = false }) {
  const [isDefault, setIsDefault] = useState(false);
  const [icon, setIcon] = useState(assetKind);
  const imgRef = useRef();

  useEffect(() => {
    let mounted = true;
    setIcon(assetKind);
    setIsDefault(assetKind?.split("/").pop() === "default.svg");
    if (!assetKind || assetKind.includes("/")) {
      return () => {
        mounted = false;
      };
    }
    getAssetKindValueLabel(assetKind).then((option) => {
      if (mounted) {
        const resolvedIcon = option?.icon || assetKind;
        setIcon(resolvedIcon);
        setIsDefault(resolvedIcon?.split("/").pop() === "default.svg");
      }
    });
    return () => {
      mounted = false;
    };
  }, [assetKind]);

  const onImageError = () => {
    imgRef.current.src = "/assets/workflows/icons/INDUSTRY ICONS/default.svg";
    setIsDefault(true);
  };
  return (
    <StyledImg
      ref={imgRef}
      src={`/assets/workflows/icons/INDUSTRY ICONS/${icon}`}
      onError={onImageError}
      width={width}
      $white={white}
      $isDefault={isDefault}
    />
  );
}
